import { FileResponse } from '@/helpers/hubspot/types';
import logError from '@/helpers/logError';
import { Dispatch } from 'react';
import { v4 } from 'uuid';
import { ReplaceVirtuallyFormState } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';
import { PictureStepActions } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/steps/PictureStep/state';
import { getHubspotFileFolder } from './getHubspotFileFolder';
import { ReplaceVirtuallyFormActionMap } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/reducer';

export const uploadImage = (
	state: ReplaceVirtuallyFormState,
	dispatch: Dispatch<ReplaceVirtuallyFormActionMap>,
	images: File[],
) => {
	// If there are no images, then there is nothing to do.
	if (images.length < 1) {
		return;
	}

	const uploadBatchId = v4();

	const addImagesToHubspot = async (files: File[]) => {
		const formData = new FormData();
		files.forEach((file) => {
			formData.append('files', file);
		});

		dispatch({
			type: PictureStepActions.START_IMAGE_UPLOAD,
			payload: images.map((image) => ({ file: image, uploadBatchId })),
		});

		const hubspotFolderId = await getHubspotFileFolder(state, dispatch);
		if (hubspotFolderId) {
			formData.append('folderId', hubspotFolderId);
		}

		try {
			const response = await fetch(`/api/hubspot/file/`, {
				method: 'POST',
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to upload files to HubSpot');
			}

			const data = (await response.json()) as FileResponse;
			// Return the data
			return { files: data.files, uploadBatchId };
		} catch (error) {
			logError(error as Error);
			return { files: [], uploadBatchId };
		}
	};

	addImagesToHubspot(images)
		.then((hubspotResult) => {
			dispatch({
				type: PictureStepActions.END_HUBSPOT_FILE_UPLOAD,
				payload: hubspotResult,
			});
		})
		.catch((error) => {
			console.log('Error uploading images', error);
			logError(error as Error);
		});
};
